<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <full-calendar
          :events="events"
          :config="calendarConfig"
          @event-click="onEventClick"
          @day-click="onDayClick"
        />
      </v-col>
    </v-row>

    <!-- Booking Dialog -->
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ editedEvent.id ? "Edit" : "New" }} Booking</span
          >
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-select
              v-model="editedEvent.artistId"
              :items="artists"
              item-text="name"
              item-value="id"
              label="Select Artist"
              required
            />

            <v-select
              v-model="editedEvent.rateId"
              :items="rates"
              item-text="name"
              item-value="id"
              label="Select Rate"
              required
            />

            <v-select
              v-model="editedEvent.productionId"
              :items="productions"
              item-text="title"
              item-value="id"
              label="Select Production"
              required
            />

            <v-menu
              ref="startTimeMenu"
              v-model="startTimeMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="editedEvent.start"
                  label="Start Time"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="editedEvent.start"
                format="24hr"
                full-width
              ></v-time-picker>
            </v-menu>

            <v-menu
              ref="endTimeMenu"
              v-model="endTimeMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="editedEvent.end"
                  label="End Time"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="editedEvent.end"
                format="24hr"
                full-width
              ></v-time-picker>
            </v-menu>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="saveEvent">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";

export default {
  // components: {
  //   FullCalendar,
  // },
  data() {
    return {
      dialog: false,
      startTimeMenu: false,
      endTimeMenu: false,
      events: [],
      editedEvent: {},
      artists: [
        { id: 1, name: "John Doe" },
        { id: 2, name: "Jane Smith" },
      ],
      rates: [
        { id: 1, name: "Standard", amount: 500 },
        { id: 2, name: "Premium", amount: 1000 },
      ],
      productions: [
        { id: 1, company: "DreamWorks", title: "Space Adventure" },
        { id: 2, company: "Indie Films", title: "Quiet Storm" },
      ],
      calendarConfig: {
        defaultView: "agendaWeek",
        selectable: true,
        editable: true,
        header: {
          left: "prev,next today",
          center: "title",
          right: "month,agendaWeek,agendaDay",
        },
        eventLimit: true,
      },
    };
  },
  methods: {
    onDayClick(date) {
      this.editedEvent = {
        id: null,
        artistId: null,
        rateId: null,
        productionId: null,
        start: date.format("YYYY-MM-DDTHH:mm:ss"),
        end: date.add(1, "hours").format("YYYY-MM-DDTHH:mm:ss"),
      };
      this.dialog = true;
    },
    onEventClick({ event }) {
      this.editedEvent = { ...event };
      this.dialog = true;
    },
    async saveEvent() {
      const payload = {
        ...this.editedEvent,
        title: this.getEventTitle(this.editedEvent),
        start: this.editedEvent.start,
        end: this.editedEvent.end,
      };

      if (!this.editedEvent.id) {
        const res = await fetch("https://api.example.com/bookings", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const saved = await res.json();
        payload.id = saved.id;
        this.events.push(payload);
      } else {
        await fetch(`https://api.example.com/bookings/${payload.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const idx = this.events.findIndex((e) => e.id === payload.id);
        if (idx !== -1) this.$set(this.events, idx, payload);
      }

      this.dialog = false;
    },
    getEventTitle(event) {
      const artist = this.artists.find((a) => a.id === event.artistId);
      const prod = this.productions.find((p) => p.id === event.productionId);
      return `${artist?.name} - ${prod?.title}`;
    },
  },
};
</script>

<style scoped>
.headline {
  font-weight: bold;
}
</style>
